import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=2000240c&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&id=2000240c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000240c",
  null
  
)

export default component.exports